import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propBool, propChildren, propNumber, } from '../../helpers/custom-prop-types';
/**
 * @deprecated TS化済: src/components/ui/FeedBack/Spinner/Spinner.tsx
 */
export const LoadingSpinner = ({ isColorful }) => (_jsx("div", { className: `loader-spinner ${isColorful ? 'color' : ''}` }));
LoadingSpinner.propTypes = {
    isColorful: propBool(),
};
LoadingSpinner.defaultProps = {
    isColorful: true,
};
/**
 * @deprecated TS化済: src/components/ui/FeedBack/AllLoading/AllLoading.tsx
 */
export const AllLoaderComponent = () => (_jsx("div", Object.assign({ className: 'l-loader' }, { children: _jsx("div", Object.assign({ className: 'loading' }, { children: _jsx(LoadingSpinner, {}) })) })));
export const AllLoader = ({ children, isLoading }) => {
    if (isLoading) {
        return _jsx(AllLoaderComponent, {});
    }
    return children;
};
AllLoader.propTypes = {
    children: propChildren(),
    isLoading: propBool().isRequired,
};
AllLoader.defaultProps = {
    children: null,
};
export const ProcessLoader = (props) => {
    const { backgroundIsTransparent } = props;
    const style = {
        backgroundColor: backgroundIsTransparent ? 'transparent' : undefined,
    };
    return (_jsx("div", Object.assign({ className: 'process-loader', style: style }, { children: _jsx("div", Object.assign({ className: 'process-loader-spinner' }, { children: _jsx("div", Object.assign({ className: 'loading' }, { children: _jsx(LoadingSpinner, {}) })) })) })));
};
ProcessLoader.propTypes = {
    backgroundIsTransparent: propBool(),
};
ProcessLoader.defaultProps = {
    backgroundIsTransparent: false,
};
export const CurrentProcessLoader = ({ marginBottom, marginTop }) => {
    const style = {
        textAlign: 'center',
        width: '100%',
    };
    if (marginTop !== null) {
        style.marginTop = `${marginTop}px`;
    }
    if (marginBottom !== null) {
        style.marginBottom = `${marginBottom}px`;
    }
    return (_jsx("div", Object.assign({ style: style }, { children: _jsx(LoadingSpinner, {}) })));
};
CurrentProcessLoader.propTypes = {
    marginBottom: propNumber(),
    marginTop: propNumber(),
};
CurrentProcessLoader.defaultProps = {
    marginBottom: null,
    marginTop: null,
};
